import { Flex, Span } from "@goodfill/ui-components";

export const PaymentHistorySection = () => {
  return (
    <Flex direction="col" verticalMargin={2} horizontalMargin={8} horizontalPadding={8} gap={8} width="w-full">
      <Flex direction="row" items="center" justify="between" verticalMargin={4}>
        <Span font="semibold" size="lg">
          Payment
        </Span>
      </Flex>
    </Flex>
  );
};
